/**
 * Production-ready logging utility
 * Only logs in development mode, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development'

export default {
  log(...args) {
    if (isDevelopment) {
      console.log(...args)
    }
  },

  error(...args) {
    // Always log errors, even in production
    console.error(...args)
  },

  warn(...args) {
    if (isDevelopment) {
      console.warn(...args)
    }
  },

  info(...args) {
    if (isDevelopment) {
      console.info(...args)
    }
  },

  debug(...args) {
    if (isDevelopment) {
      console.debug(...args)
    }
  }
}
